module.exports = __webpack_public_path__ + "img/paperplane.b3ca8dab.svg";